import { ORDER_SIDE } from '../../constants';

const NEW_RELIC_PAGE_ACTION = {
  SEND_ORDER_BUY: 'sendOrderBuy',
  SEND_ORDER_SELL: 'sendOrderSell',

  FORM_SUBMIT: 'formSubmit',
};

export const NEW_RELIC_FORM_NAME = {
  BUY_SELL: 'buySell',
  // Ideally we should not use this but it's a fallback for when we don't know the form name
  UNKNOWN: 'unknown',
};

class CustomEventFactory {
  /**
   * @param {Object} params
   * @param {Object} params.newRelic
   * @param {string} params.form
   * @param {string} params.buttonText
   * @returns
   */
  formSubmit({ newRelic, form, buttonText }) {
    newRelic.addPageAction(NEW_RELIC_PAGE_ACTION.FORM_SUBMIT, { form, buttonText });
  }

  /**
   * @param {Object} params
   * @param {Object} params.newRelic
   * @param {string} params.request
   * @param {string} params.response
   * @param {Record<string, any>} params.response
   * @returns
   */
  sendOrderOutcome({ newRelic, request, response }) {
    const eventPayload = {
      success: response.status === 'Accepted',
      value: request?.payload?.Value,
      instrumentId: request?.payload?.InstrumentId,
    };

    if (request?.payload?.Side === ORDER_SIDE.Buy) {
      newRelic.addPageAction(NEW_RELIC_PAGE_ACTION.SEND_ORDER_BUY, eventPayload);
    } else if (request?.payload?.Side === ORDER_SIDE.Sell) {
      newRelic.addPageAction(NEW_RELIC_PAGE_ACTION.SEND_ORDER_SELL, eventPayload);
    } else {
      console.error('CustomEventFactory.sendOrderOutcome Error. Unknown order side. Event will not be tracked.', {
        request,
        response,
      });
    }
  }
}

export const customEventFactory = new CustomEventFactory();
